// Address from the client's La Courbe product book. Its map page prints 269,
// while the address copy says 259; confirm the house number before publication.
// Searches, rather than asserted coordinates, intentionally resolve the location.
export const developmentLocation = {
  id: "la-courbe",
  name: "La Courbe Tower",
  address: "Rua Deputado Waldemiro Pedroso, 259 · Novo Mundo, Curitiba",
  query: "Rua Deputado Waldemiro Pedroso 259 Novo Mundo Curitiba PR",
  source: "La Courbe - Book Produto_Nova_Foto.pdf",
};

export const nearbyCategories = [
  { id: "todos", label: "Todos" },
  { id: "mobilidade", label: "Mobilidade" },
  { id: "compras", label: "Compras" },
  { id: "saude", label: "Saúde" },
  { id: "lazer", label: "Cultura e lazer" },
];

// Primary sources checked 2026-09-09. No travel times or distance estimates.
export const nearbyPlaces = [
  {
    id: "terminal-capao-raso",
    name: "Terminal Capão Raso",
    category: "mobilidade",
    detail: "Transporte integrado",
    address: "Av. República Argentina, 5229 · Novo Mundo",
    query: "Terminal Capão Raso Avenida República Argentina 5229 Curitiba",
    source: "https://locais.curitiba.pr.gov.br/terminal-capao-raso/637",
  },
  {
    id: "estacao-trabalhador",
    name: "Estação Hospital do Trabalhador",
    category: "mobilidade",
    detail: "Estação-tubo · sentido norte",
    address: "Av. República Argentina, 4383 · Novo Mundo",
    query: "Estação Tubo Hospital do Trabalhador Norte República Argentina 4383 Curitiba",
    source: "https://locais.curitiba.pr.gov.br/estacao-tubo-hospital-do-trabalhador---norte/1676/",
  },
  {
    id: "palladium",
    name: "Shopping Palladium",
    category: "compras",
    detail: "Lojas, gastronomia e entretenimento",
    address: "Av. Presidente Kennedy, 4121 · Portão",
    query: "Shopping Palladium Avenida Presidente Kennedy 4121 Curitiba",
    source: "https://palladiumcuritiba.com.br/fale-conosco/",
  },
  {
    id: "mercado-capao-raso",
    name: "Mercado Municipal Capão Raso",
    category: "compras",
    detail: "Comércio e serviços para o dia a dia",
    address: "Rua Otto Cabél, 51 · Novo Mundo",
    query: "Mercado Municipal Capão Raso Rua Otto Cabel 51 Curitiba",
    source: "https://www.urbs.curitiba.pr.gov.br/portal/equipamentos/mercado-municipal-capao-raso/",
  },
  {
    id: "hospital-trabalhador",
    name: "Hospital do Trabalhador",
    category: "saude",
    detail: "Complexo hospitalar",
    address: "Av. República Argentina, 4406 · Novo Mundo",
    query: "Hospital do Trabalhador Avenida República Argentina 4406 Curitiba",
    source: "https://www.saude.pr.gov.br/Endereco/Hospital-do-Trabalhador",
  },
  {
    id: "portao-cultural",
    name: "Portão Cultural",
    category: "lazer",
    detail: "Museu, cinema e literatura",
    address: "Av. República Argentina, 3430 · Portão",
    query: "Espaço Portão Cultural Avenida República Argentina 3430 Curitiba",
    source: "https://locais.curitiba.pr.gov.br/espaco-portao-cultural/36",
  },
];

export function mapSearchUrl(query) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function mapEmbedUrl(query) {
  return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=15&hl=pt-BR&output=embed`;
}
